export function updateArrayIndexFp<T>(
  array: Array<T>,
  index: number,
  updater: (field: T) => T,
): Array<T> {
  // @ts-expect-error TODO(flow-migration)
  return Object.values({ ...array, [index]: updater(array[index]) });
}
